// 予約ラベルのフェードアウトを実装する関数
function fadeOutReserveLabel() {
  // 予約ラベル要素を取得
  const reserveLabel = document.querySelector('.reserve-label');
  
  if (!reserveLabel) return;

  // フェードアウトのための初期設定
  reserveLabel.style.transition = 'opacity 300ms ease-out';
  reserveLabel.style.opacity = '1';

  // フェードアウトアニメーションを開始
  reserveLabel.style.opacity = '0';

  // アニメーション完了後に要素を削除
  reserveLabel.addEventListener('transitionend', function handler(event) {
    if (event.propertyName === 'opacity') {
      reserveLabel.removeEventListener('transitionend', handler);
      reserveLabel.remove();
    }
  });
}

// クリックイベントの設定例
document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('.reserve-label .close-button');
  if (closeButton) {
    closeButton.addEventListener('click', fadeOutReserveLabel);
  }
});